import PropTypes from 'prop-types';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';
var propTypes = {
  /**
  * The type of callout
  */
  variant: PropTypes.oneOf(['standard', 'overlay', 'inverse']),

  /**
  * @deprecated
  * Use `size` prop instead
  */
  sizeVariant: deprecatedProp(PropTypes.oneOf(['standard', 'super', 'mini']), DEPRECATED_PROP_MESSAGES.size),

  /**
  * The size variation
  */
  size: PropTypes.oneOf(['standard', 'super', 'mini']),

  /**
  * The visual style of the Callout
  */
  skin: PropTypes.oneOf(['standard', 'announcement', 'discount', 'holiday', 'error', 'new', 'foil']),

  /**
  * The border of the Callout
  */
  border: PropTypes.oneOf(['standard', 'none']),

  /**
  * Whether or not the Callout should render its content with ALL CAPS
  *
  * @deprecated Use `textAllCaps` core prop instead
  */
  allCaps: deprecatedProp(PropTypes.bool, 'Callout(allCaps prop deprecation): Consider using core prop `textAllCaps` instead.')
};
var Callout = createComponent({
  displayName: 'Callout',
  root: 'span',
  propTypes: propTypes,
  propConfig: {
    derivedProps: function derivedProps(props) {
      var _props$skin = props.skin,
          skin = _props$skin === void 0 ? 'standard' : _props$skin,
          _props$border = props.border,
          border = _props$border === void 0 ? 'standard' : _props$border,
          _props$variant = props.variant,
          variant = _props$variant === void 0 ? 'standard' : _props$variant,
          _props$sizeVariant = props.sizeVariant,
          sizeVariant = _props$sizeVariant === void 0 ? 'standard' : _props$sizeVariant,
          _props$size = props.size,
          size = _props$size === void 0 ? sizeVariant : _props$size,
          _props$allCaps = props.allCaps,
          allCaps = _props$allCaps === void 0 ? false : _props$allCaps;
      return {
        skin: skin,
        border: border,
        variant: variant,
        size: size,
        allCaps: allCaps
      };
    },
    classNames: function classNames(_props, derivedProps) {
      var skin = derivedProps.skin,
          border = derivedProps.border,
          variant = derivedProps.variant,
          allCaps = derivedProps.allCaps,
          size = derivedProps.size;
      var classNameSet = new Set(['swan-callout']);
      if (skin !== 'standard') classNameSet.add("swan-callout-skin-".concat(skin));
      if (border === 'none') classNameSet.add('swan-callout-borderless');
      if (variant === 'overlay') classNameSet.add('swan-callout-overlay');
      if (variant === 'inverse') classNameSet.add('swan-callout-inverse');
      if (size === 'mini') classNameSet.add('swan-callout-mini');
      if (allCaps) classNameSet.add('swan-text-all-caps');
      return classNameSet;
    }
  }
});
Callout.defaultProps = {
  variant: 'standard',
  size: 'standard',
  skin: 'standard',
  border: 'standard'
};
export { Callout };